export let categoriasRedux=(valor)=>{ return {type:"CATEGORIAS",payload:valor} };
export let categoriasEstado=(valor)=>{ return {type:"CATEGORIAS_ESTADO",payload:valor} };